<template>
  <public-page :skip-auth-redirect="true">
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="12" lg="6" md="8" sm="12">
        <v-card elevation="4">
          <v-toolbar color="indigo" dark>
            <v-toolbar-title>Password Reset</v-toolbar-title>

            <v-spacer></v-spacer>
          </v-toolbar>

          <div v-if="!success">
            <v-card-text>
              <p>Introduce your new password below:</p>
              <v-alert
                v-if="error"
                type="error"
                border="right"
                colored-border
                elevation="2"
              >
                {{ error }}
              </v-alert>
              <v-form
                lazy-validation
                v-model="valid"
                id="form"
                ref="form"
                action="POST"
                @submit.prevent="passwordReset"
              >
                <v-container class="text-center">
                  <v-text-field
                    label="Password"
                    hint="At least 8 characters"
                    :append-icon="togglepass ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="togglepass ? 'text' : 'password'"
                    :min="0"
                    :counter="25"
                    v-model="password1"
                    :rules="passRules"
                    @click:append="togglepass = !togglepass"
                  ></v-text-field>
                  <v-text-field
                    label="Password confirmation"
                    hint="At least 8 characters"
                    :append-icon="togglepass ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="togglepass ? 'text' : 'password'"
                    :min="0"
                    :counter="25"
                    v-model="password2"
                    :rules="passRules"
                    @click:append="togglepass = !togglepass"
                  ></v-text-field>
                </v-container>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                type="submit"
                form="form"
                color="primary"
                :disabled="!valid"
              >
                Change Password
              </v-btn>
            </v-card-actions>
          </div>
          <div v-else>
            <v-card-text>
              <p>Your password has been changed successfully.</p>
            </v-card-text>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </public-page>
</template>

<script>
import { API } from "@/axios-config";
import PublicPage from "@/components/PublicPage";
import { useUserStore } from "@/store/user";

export default {
  name: "PasswordReset",
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  components: {
    PublicPage,
  },
  data() {
    return {
      password1: "",
      password2: "",
      passRules: [
        (v) => !!v || "Password is required",
        (v) =>
          (v && v.length > 7) ||
          "The password must be longer than 7 characters",
      ],
      togglepass: false,
      valid: false,
      error: null,
      success: false,
    };
  },
  methods: {
    async passwordReset() {
      try {
        await API.post("/api/v1/accounts/password/reset/", {
          password1: this.password1,
          password2: this.password2,
          token: this.$route.params.token,
        });
        this.success = true;
      } catch (error) {
        console.log(error);
        this.error =
          "An error ocurred while changing your password. Please try again.";
      }
    },
  },
};
</script>

<style scoped>
.v-btn,
.v-card {
  border-radius: 4px;
}
.v-card__title {
  text-transform: uppercase;
}
</style>